import response from 'fe-coms/utils/response'
import Vue from '@/app.js'
const http = new Vue().$http

const API = {
  // 查询领用单创建状态
  getCreateRecipientsResult: {
    type: 'get',
    url: '/mall/require/getCreateRecipientsResult'
  }
}

export default {
  searchState ({commit, state, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      const api = API.getCreateRecipientsResult
      if (!state.requireTimer) {  // 不存在定时器
        const timer = setInterval(async () => {
          if (state.startPolling) { // 是否开始轮询
            response(http(api.type, api.url, { key: payload })) // 查询领用单创建状态
              .then(res => {
                if (res.isOk) {
                  if (res.content.status === 'SUCCESS' && state.startPolling) { // 创建成功
                    const count = res.content.recipientsCodes.length
                    let html = ''
                    if (count > 1) {
                      html = `
                          <div>系统创建了多个领用单,请在领用单列表中查看并完善</div>
                          <div style="text-align: right">
                              <a href="#/requisition/list">
                                  <div class="background-color-primary notify_pr_primary_button" onclick="(function () { window.vueInstantiation.pr_require_submit_notify.close() })()">查看详情</div>
                              </a>
                          </div>
                        `
                    } else if (count === 1) {
                      html = `
                       <div>系统创建了一个领用单,可以点击继续完善编辑领用单</div>
                        <div style="text-align: right">
                            <a>
                                <div class="font-color-primary notify_pr_text_button" onclick="(function () { window.vueInstantiation.pr_require_submit_notify.close() })()">暂不处理</div>
                            </a>
                            <a href="#/requisition/edit?code=${res.content.recipientsCodes[0]}&type=REQUIRE">
                                <div class="background-color-primary notify_pr_primary_button" onclick="(function () { window.vueInstantiation.pr_require_submit_notify.close() })()">继续完善</div>
                            </a>
                        </div>
                      `
                    }
                    commit('SET_STARTPOLLING', false)
                    window.vueInstantiation.pr_require_submit_notify = window.vueInstantiation.$notify({
                      type: 'success',
                      title: '领用单已创建',
                      dangerouslyUseHTMLString: true,
                      duration: 0,
                      message: html
                    })
                  } else if (res.content.status === 'FAILED' && state.startPolling) { // 创建失败
                    commit('SET_STARTPOLLING', false)
                    window.vueInstantiation.$notify({
                      type: 'error',
                      title: '领用单创建失败',
                      duration: 0
                    })
                  }
                  resolve(res)
                } else {
                  reject(new Error('请求失败！'))
                }
              })
              .catch((Error) => {
                reject(Error)
              })
          } else {
            clearInterval(state.requireTimer)
            commit('SET_REQUIRETIMER', null)
          }
        }, 1000)
        commit('SET_REQUIRETIMER', timer)
      }
    })
  }
}
